// History subsection questionnaire constants
export enum HistoryQuestionnaireItem {
  MEDICAL_BACKGROUND_HISTORY = 'medical-background/history',
  MEDICAL_BACKGROUND_HISTORY_60_DAY_ER = 'medical-background/history/60-day-er',
  MEDICAL_BACKGROUND_HISTORY_ER_NOTES = 'medical-background/history/er-notes',
  MEDICAL_BACKGROUND_HISTORY_60_DAY_HOSPITAL = 'medical-background/history/60-day-hospital',
  MEDICAL_BACKGROUND_HISTORY_HOSPITAL_NOTES = 'medical-background/history/hospital-notes',
  MEDICAL_BACKGROUND_HISTORY_60_DAY_INJURIES = 'medical-background/history/60-day-injuries',
  MEDICAL_BACKGROUND_HISTORY_INJURY_NOTES = 'medical-background/history/injury-notes',
  MEDICAL_BACKGROUND_HISTORY_60_DAY_FALLS = 'medical-background/history/60-day-falls',
  MEDICAL_BACKGROUND_HISTORY_FALL_NOTES = 'medical-background/history/fall-notes',
  MEDICAL_BACKGROUND_HISTORY_60_DAY_INFECTIONS = 'medical-background/history/60-day-infections',
  MEDICAL_BACKGROUND_HISTORY_INFECTION_NOTES = 'medical-background/history/infection-notes',
  MEDICAL_BACKGROUND_HISTORY_60_DAY_MD = 'medical-background/history/60-day-md',
  MEDICAL_BACKGROUND_HISTORY_MD_NOTES = 'medical-background/history/md-notes',
  MEDICAL_BACKGROUND_HISTORY_FUNCTIONAL_LIMITATIONS = 'medical-background/history/functional-limitations',
  MEDICAL_BACKGROUND_HISTORY_ACTIVITIES_PERMITTED = 'medical-background/history/activities-permitted',
  MEDICAL_BACKGROUND_HISTORY_MEDICAL_HISTORY = 'medical-background/history/medical-history',
  MEDICAL_BACKGROUND_HISTORY_SURGICAL_HISTORY = 'medical-background/history/surgical-history'
}
